const regex = {
  email: /^[\w+\-.]+@[a-z\d\-]+(\.[a-z]+)*\.[a-z]+$/m,
  phone: /^(?:(?:\+|00)33|0)\s*[6-7](?:[\s]*\d{1}){8}$/m,
  name: /([a-zA-Zàéèâêîôç\s]|[a-zàéèâêîôçA-Z\s][\. \'])+/i,
  address: /^([a-zA-Zàéèâêîôç0-9\s]|[a-zàéèâêîôçA-Z0-9\s][\. \'])+$/i,
  zipCode: /^([0-9]{4}|[0-9]{5})$/m,
  number: /^[0-9]{1,5}$/,
};

export default regex;
